const scale = {
  xs: '4px',
  sm: '8px',
  m: '12px',
  md: '16px',
  mmd: '24px',
  lg: '32px',
  xl: '64px',
};
const array = [0, scale.xs, scale.sm, scale.md, scale.lg, scale.xl];
export default {
  ...array,
  ...scale,
};
